<template>
  <div class="col-lg-7 animated fadeInRight">
    <div class="mail-box-header">
      <h2>Lista de Clientes</h2>

      <form>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="searchForm.form.fullName"
          />

          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="searchClients"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome Completo</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr v-for="(listItem, listIdx) in clientList.list" :key="listIdx">
            <td>{{ listItem.fullName }}</td>
            <td class="list-command">
              <button
                class="btn btn-outline"
                @click="selectClient(listItem, listIdx)"
              >
                <i class="fa fa-edit text-success"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        form: {
          fullName: '',
        },
        control: {},
      },
      clientList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  watch: {
    'searchForm.form.fullName'() {
      this.searchClients();
    },
  },
  mounted() {
    this.listClients();
  },
  methods: {
    selectClient(item) {
      this.$emit('select-client', item);
    },
    async listClients() {
      const clientList = await this.$store.dispatch('CLIENT/ListAll');
      this.clientList.originalList = clientList;
      this.searchClients();
    },
    searchClients() {
      const listFiltered = this.clientList.originalList.filter(item => {
        return (
          item.fullName
            .toUpperCase()
            .indexOf(this.searchForm.form.fullName.toUpperCase()) > -1
        );
      });
      this.clientList.list = listFiltered;
    },
  },
};
</script>